module.exports = __webpack_public_path__ + "assets/img/budapark4-320.a8d376f5.webp";